<template>
    <div class="locked-out">
        <div class="locked-header">
            <div class="lock-icon-wrapper">
                <img src="@/assets/lock-icon.png" alt="warning" class="warning-icon">
            </div>
            <h1>Access temporarily locked.</h1>
        </div>
        <div class="locked-content">
            <p>
                For your security, we've temporarily locked access after multiple unsuccessful attempts. Contact GeneSight Customer Service for further assistance.
            </p>
            <div class="contact-row">
                <a :href="`tel:${$config.customerSupportPhoneDial}`">{{ $config.customerSupportPhoneDisplay }}</a>
                |
                <a href="https://static.myriad.com/genesys-chat/1.0.0/index.html?formType=genesight" target="_blank">Live chat</a>
                |
                <a href="mailto:support@genesight.com">support@genesight.com</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Locked"
};
</script>

<style lang="scss" scoped>
.locked-out {
    .locked-header {
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .lock-icon-wrapper {
            border-radius: 40.2px;
            background: var(--Color-orange-dark-50, #FFF4ED);
            width: 56px;
            height: 56px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 16px;

            img {
                width: 24px;
            }
        }

        h1 {
            color: #000;
            font-family: var(--font-family-Inter, Inter);
            font-size: var(--font-size-hxl, 36px);
            font-style: normal;
            font-weight: 400;
            line-height: 122%;
            letter-spacing: -0.72px;
            margin-bottom: 0;
        }
    }

    .locked-content {
        margin-left: 72px;

        p {
            color: #000;
            font-family: var(--font-family-Inter, Inter);
            font-size: var(--font-size-tm, 16px);
            font-style: normal;
            font-weight: 400;
            line-height: 150%; /* 24px */
            letter-spacing: -0.16px;
            margin-bottom: 15px;
        }

        .contact-row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            max-width: 453px;

            color: var(--Color-gray-400, #9AA4B2);
            font-family: var(--font-family-Inter, Inter);
            font-size: var(--font-size-tm, 16px);
            font-style: normal;
            font-weight: 400;
            line-height: 150%;
            letter-spacing: -0.16px;

            a {
                color: var(--Color-blue-bright-500, #0691EF);
                font-family: var(--font-family-Inter, Inter);
                font-size: var(--font-size-tm, 16px);
                font-style: normal;
                font-weight: 400;
                line-height: 150%; /* 24px */
                letter-spacing: -0.16px;
                text-decoration: none;
            }
        }
    }
}
</style>
